import './chat.css';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { dayLabel, fmtDateTime, fmtTime, shorten } from '../../lib/format';
import { chatTabPath, kanzleiChat, kanzleiOpenThread, unreadRows } from './data';

// Leiste „✉ Neue Nachricht“ ganz oben. Ohne clientId: alle sichtbaren Mandanten mit Ungelesenem, mit clientId: nur dieser.
export function ChatBar({ clientId }: { clientId?: string }) {
  const data = kanzleiChat.useData();
  const open = kanzleiOpenThread.useOpen();
  const navigate = useNavigate();
  const [all, setAll] = useState(false);
  const rows = unreadRows(data, open).filter((r) => !clientId || r.clientId === clientId);
  if (!rows.length) return null;
  const cut = rows.length > 4 && !all;

  return (
    <div className="msgbar" role="status">
      <div className="mb-h">{rows.length === 1 ? '✉ Neue Nachricht' : `✉ ${rows.length} Mandanten haben geschrieben`}</div>
      {(cut ? rows.slice(0, 3) : rows).map((r) => {
        const l = r.latest;
        // Text in Anführungszeichen, Datei mit Symbol
        const what = l ? (l.text ? `„${shorten(l.text, 90)}“` : `📄 ${l.fileName ?? ''}`) : '';
        // Heute nur die Uhrzeit, sonst mit Datum
        const when = l ? (dayLabel(l.at) === 'Heute' ? fmtTime(l.at) : fmtDateTime(l.at)) : '';
        return (
          <div className="mb-r" key={r.clientId}>
            <div className="tx">
              <b>{r.contactName}</b> · {r.clientName}
              {!r.own && <span className="note"> · Chat mit {r.staffName}</span>}
              {l && (
                <small>
                  {what} · {when}
                </small>
              )}
            </div>
            <button
              type="button"
              className="btn sm dark"
              onClick={() => navigate(chatTabPath(r.clientId, r.own ? undefined : r.staffId))}
            >
              {r.own ? 'Antworten' : 'Mitlesen'}
            </button>
          </div>
        );
      })}
      {rows.length > 4 && (
        <button type="button" className="btn sm chat-more" aria-expanded={!cut} onClick={() => setAll(!all)}>
          {cut ? `Alle anzeigen (${rows.length})` : 'Weniger anzeigen'}
        </button>
      )}
    </div>
  );
}
